import { Badge } from '@eventbrite/eds-badge';
import { Icon } from '@eventbrite/eds-icon';
import { CartChunky } from '@eventbrite/eds-iconography';
import { GenericLazyString } from '@eventbrite/i18n';
import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

import './TicketSelectionTotal.scss';

export interface TicketSelectionTotalProps {
    className?: string;
    count: number;
    total: string | GenericLazyString;
    totalClassName?: string;
}

export const TicketSelectionTotal: FunctionComponent<
    TicketSelectionTotalProps
> = ({ className, count, total = '', totalClassName }) => {
    return (
        <div
            className={classnames('ticket-selection-total', className)}
            data-testid="ticket-selection-total"
        >
            <span>
                <Badge
                    count={count}
                    bgColor={'grey-200'}
                    contentColor={'grey-900'}
                >
                    <Icon type={<CartChunky />} />
                </Badge>
            </span>
            <span
                className={classnames(
                    'ticket-selection-total-cost',
                    totalClassName,
                )}
            >
                {total}
            </span>
        </div>
    );
};

export default TicketSelectionTotal;
